import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-feedback-form',
  templateUrl: './view-feedback-form.component.html',
  styleUrls: ['./view-feedback-form.component.scss']
})
export class ViewFeedbackFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
